import Layout from '@/components/layout/index.vue'

export default {
  path: 'purchasesettings',
  name: 'Purchasesettings',
  meta: {},
  component: Layout,
  redirect: { name: 'Purchasesettings.Currencyexchange' },
  children: [
    {
      path: 'currencyexchange',
      name: 'Purchasesettings.Currencyexchange',
      meta: {},
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/currencyexchange/index.ts')
    },
    {
      path: 'currencyexchange/add',
      name: 'Purchasesettings.Currencyexchange.Add',
      meta: { title: 'common.add', dep: 'Purchasesettings.Currencyexchange' },
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/currencyexchange/add.ts')
    },
    {
      path: 'currencyexchange/modify/:id',
      name: 'Purchasesettings.Currencyexchange.Modify',
      meta: { title: 'common.modify', dep: 'Purchasesettings.Currencyexchange' },
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/currencyexchange/modify.ts')
    },
    {
      path: 'taxexchange',
      name: 'Purchasesettings.Taxexchange',
      meta: {},
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/taxexchange/index.ts')
    },
    {
      path: 'taxexchange/add',
      name: 'Purchasesettings.Taxexchange.Add',
      meta: { title: 'common.add', dep: 'Purchasesettings.Taxexchange' },
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/taxexchange/add.ts')
    },
    {
      path: 'taxexchange/modify/:id',
      name: 'Purchasesettings.Taxexchange.Modify',
      meta: { title: 'common.modify', dep: 'Purchasesettings.Taxexchange' },
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/taxexchange/modify.ts')
    },
    {
      path: 'paymentterm',
      name: 'Purchasesettings.Paymentterm',
      meta: {},
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/paymentterm/index.ts')
    },
    {
      path: 'paymentterm/add',
      name: 'Purchasesettings.Paymentterm.Add',
      meta: { title: 'common.add', dep: 'Purchasesettings.Paymentterm' },
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/paymentterm/add.ts')
    },
    {
      path: 'paymentterm/modify/:id',
      name: 'Purchasesettings.Paymentterm.Modify',
      meta: { title: 'common.modify', dep: 'Purchasesettings.Paymentterm' },
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/paymentterm/modify.ts')
    },
    {
      path: 'tradeterm',
      name: 'Purchasesettings.Tradeterm',
      meta: {},
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/tradeterm/index.ts')
    },
    {
      path: 'tradeterm/add',
      name: 'Purchasesettings.Tradeterm.Add',
      meta: { title: 'common.add', dep: 'Purchasesettings.Tradeterm' },
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/tradeterm/add.ts')
    },
    {
      path: 'tradeterm/modify/:id',
      name: 'Purchasesettings.Tradeterm.Modify',
      meta: { title: 'common.modify', dep: 'Purchasesettings.Tradeterm' },
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/tradeterm/modify.ts')
    },
    {
      path: 'supplyratio',
      name: 'Purchasesettings.Supplyratio',
      meta: {},
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/supplyratio/index.ts')
    },
    {
      path: 'supplyratio/add',
      name: 'Purchasesettings.Supplyratio.Add',
      meta: { title: 'common.add', dep: 'Purchasesettings.Supplyratio' },
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/supplyratio/add.ts')
    },
    {
      path: 'supplyratio/modify/:goodsNo',
      name: 'Purchasesettings.Supplyratio.Modify',
      meta: { title: 'common.modify', dep: 'Purchasesettings.Supplyratio' },
      component: () => import(/* webpackChunkName: "purchasesettings" */ '@/views/setting/purchasesettings/supplyratio/modify.ts')
    }
  ]
}
